module.exports = __webpack_public_path__ + "static/media/intro-video-captions-es.8f2f383f.vtt";